import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CvSectionText,
  CvSectionTextResponse,
  UpdateCvSectionTextRequest,
} from '@/../gen';

export const namespace = 'cvSectionTextEdit';
const actionCreator = actionCreatorFactory(namespace);
export const GetCvSectionText = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_TEXT');
export const SetCvSectionText = actionCreator<CvSectionTextResponse>(
  'SET_CV_SECTION_TEXT'
);
export const UpdateCvSectionText = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
  body: UpdateCvSectionTextRequest;
}>('UPDATE_CV_SECTION_TEXT');
export const DeleteCvSectionText = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('DELETE_CV_SECTION_TEXT ');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionText: CvSectionText;
}

const initialState = (): State => {
  return { cvSectionText: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionText, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionText(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionText(data.data));
    }),
    action(UpdateCvSectionText, async function(context, action) {
      const { data } = await this.proffApi.updateCvSectionText(
        action.payload.params.cv_id,
        action.payload.params.id,
        action.payload.body
      );
      context.commit(SetCvSectionText(data.data));
    }),
    action(DeleteCvSectionText, async function(context, action) {
      await this.proffApi.deleteCvSectionText(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionText(null));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionText, (state, action) => {
      state.cvSectionText = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionText: state => state.cvSectionText,
  },
};
